import createIcon from '../createIcon';

export const MobileIcon = createIcon({
  path: (
    <path
      d="M34 2.02L14 2C11.8 2 10 3.8 10 6V42C10 44.2 11.8 46 14 46H34C36.2 46 38 44.2 38 42V6C38 3.8 36.2 2.02 34 2.02ZM34 38H14V10H34V38Z"
      fill="currentColor"
    />
  ),
});
